export default "__VITE_ASSET__6bca9468__"